import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SEND_COMMUNICATION_360, SEND_COMMUNICATION_360_SUCCESS, SEND_COMMUNICATION_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* sendCommunication360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/send-communications`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SEND_COMMUNICATION_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SEND_COMMUNICATION_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_COMMUNICATION_360_ERROR, payload: error });
  }
}

export function* watchSendCommunication360() {
  yield takeEvery(SEND_COMMUNICATION_360, sendCommunication360);
}

function* sendCommunication360Saga() {
  yield all([fork(watchSendCommunication360)]);
}

export default sendCommunication360Saga;
